var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJupiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(6.5 3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.5441176 11.2731592-.0882352 11.8087095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.5 17.0062075h-16.5c5.5-2.6477318 8.25-6.5790038 8.25-11.79381615 0-5.21481232-2.75-6.51669883-8.25-3.90565953"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupiter);
export default __webpack_public_path__ + "static/media/jupiter.cb20a9b0efea8ba96ec46b5f5d5caa35.svg";
export { ForwardRef as ReactComponent };